import React, { memo } from 'react';
import { TransformWrapper, TransformComponent } from "react-zoom-pan-pinch";

const MapaMemoizado = memo(React.forwardRef(({ mapData, fundoUrl }, ref) => {

  return (
    <TransformWrapper
      initialScale={1}
      minScale={0.2} 
      maxScale={16}
      centerOnInit={true}   
      limitToBounds={false} 
      wheel={{ step: 0.08, wheelDisabled: false }}
      panning={{ velocityDisabled: true }}
      zoomAnimation={{ disabled: true }}
      doubleClick={{ disabled: true }}
    >
      {({ zoomIn, zoomOut, resetTransform, centerView }) => (
        <>
          <TransformComponent wrapperStyle={{ width: '100%', height: '100%', minHeight: '600px' }}>
            <svg
              ref={ref} 
              id="mapa"
              viewBox={`0 0 ${mapData?.width || 1000} ${mapData?.height || 1000}`}
              xmlns="http://www.w3.org/2000/svg"
              style={{ width: '100%', height: '100%', shapeRendering: 'optimizeSpeed', contentVisibility: 'auto' }}
            >
              <g id="fundo">
                {fundoUrl && (
                  <image
                    href={fundoUrl}
                    x="0"
                    y="0"
                    width={mapData?.width || 1000}
                    height={mapData?.height || 1000}
                    style={{ pointerEvents: 'none' }}
                  />
                )}
              </g>
              <g id="camada"></g>
            </svg>
          </TransformComponent>
          
          <div style={{
            position: 'absolute',
            right: '20px',
            bottom: '20px',
            zIndex: 1000,
            display: 'flex',
            gap: '10px'
          }}>
            <button type="button" onClick={() => zoomIn()} style={{ padding: '5px 10px', cursor: 'pointer' }}>+</button>
            <button type="button" onClick={() => centerView()} style={{ padding: '5px 10px', cursor: 'pointer' }} title="Centralizar">⟲</button>
            <button type="button" onClick={() => zoomOut()} style={{ padding: '5px 10px', cursor: 'pointer' }}>-</button>
          </div>
        </>
      )}
    </TransformWrapper>
  );
}));

export default MapaMemoizado;